<template>
  <div class="cart-image-wrapper" :style="{ height: height, width: width }">
    <img v-for="(image, index) in images" :key="index" :src="image.path | image(imageDimensions)" class="img-fluid">
  </div>
</template>
<script>
export default {
  props: {
    images: {
      type: Array,
      default: null
    },
    height: {
      type: String,
      default: 'auto'
    },
    width: {
      type: String,
      default: 'auto'
    }
  },
  computed: {
    imageDimensions () {
      let str = ''
      if (this.width) {
        str = Number.parseInt(this.width)
      }
      str += 'x'
      if (this.height) {
        str += Number.parseInt(this.height)
      }
      return str
    }
  }
}
</script>
